import { Company } from '../../../types/company/Company'

export interface SupplierQueryParams {
  companyId?: Company['id']
}

const supplierQueryKeys = {
  all: [{ scope: 'supplier' }] as const,
  lists: () => [{ ...supplierQueryKeys.all[0], entity: 'list' }] as const,
  list: (params: SupplierQueryParams) => [{ ...supplierQueryKeys.lists()[0], ...params }] as const
}

export default supplierQueryKeys
